import React from 'react';

/**
 * RainbowText — applies a smooth continuous brand-rainbow gradient
 * (cyan → purple → magenta → gold) across the text it wraps, using
 * background-clip: text. Used in all major headings.
 *
 * Usage:
 *   <h1><RainbowText>Building a world</RainbowText></h1>
 */
const RainbowText = ({ children }) => (
  <span className="rainbow-text">{children}</span>
);

export default RainbowText;
